<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <div v-else>
            <div>
                <b-button :variant="mode == 1 ? 'dark' : 'light'" class="mr-2" @click="switchMode(1)">
                    Handphone
                </b-button>
                <b-button :variant="mode == 2 ? 'dark' : 'light'" @click="switchMode(2)">
                    Non-Handphone
                </b-button>
            </div>
            <b-card class="mt-3">
                <h5 class="mb-0">{{ mode == 1 ? "Handphone" : "Non-Handphone" }}</h5>
                <hr />
                <b-row class="mb-3">
                    <b-col md="6">
                        <div class="small text-muted">
                            Perubahan terakhir pada {{ $helper.parseDate(mode == 1 ? hpLastUpdated.at : nonHpLastUpdated.at) }}, {{ $helper.parseHourMinute(mode == 1 ? hpLastUpdated.at : nonHpLastUpdated.at) }}<br />
                            oleh {{ mode == 1 ? hpLastUpdated.by : nonHpLastUpdated.by }}
                        </div>
                    </b-col>
                    <b-col md="6" class="text-right">
                        <b-button variant="dark" @click="addRow(-1)">
                            <i class="fa fa-plus mr-2"></i> Tambah Baris Paling Atas
                        </b-button>
                    </b-col>
                </b-row>
                <b-table responsive bordered no-local-sorting
                    :fields="fields"
                    :items="activeItems"
                    @sort-changed="onSortChanged"
                >
                    <template v-slot:cell(from)="row">
                        <b-form-input v-model="row.item.from" class="text-right" @input="sanitize(row.item, 'from')"></b-form-input>
                    </template>
                    <template v-slot:cell(to)="row">
                        <b-form-input v-model="row.item.to" class="text-right" @input="sanitize(row.item, 'to')"></b-form-input>
                    </template>
                    <template v-slot:cell(online)="row">
                        <b-form-input v-model="row.item.online" class="text-right" @input="sanitize(row.item, 'online')"></b-form-input>
                    </template>
                    <template v-slot:cell(retail)="row">
                        <b-form-input v-model="row.item.retail" class="text-right" @input="sanitize(row.item, 'retail')"></b-form-input>
                    </template>
                    <template v-slot:cell(action)="row">
                        <div style="width: 80px; margin-top: 2px">
                            <b-button size="sm" variant="primary" class="mr-2" v-b-tooltip.hover title="Tambah" @click="addRow(row.index)">
                                <i class="fa fa-plus"></i>
                            </b-button>
                            <b-button size="sm" variant="danger" v-b-tooltip.hover title="Hapus" @click="deleteRow(row.index)">
                                <i class="fa fa-times"></i>
                            </b-button>
                        </div>
                    </template>
                </b-table>
                <div class="text-right mt-3">
                    <b-button variant="success" @click="confirmSave">
                        Simpan Perubahan
                    </b-button>
                </div>
            </b-card>
        </div>
        <b-modal id="m-confirm" title="Simpan Perubahan" no-close-on-backdrop no-close-on-esc hide-footer>
            Simpan rumus umum perubahan harga gudang untuk barang <strong>{{ mode == 1 ? "Handphone" : "Non-Handphone" }}</strong>?
            <div class="small text-muted">Harga 'sampai' terakhir akan otomatis diubah menjadi 99 miliar ketika disimpan.</div>
            <div class="text-right mt-4">
                <b-button variant="primary" @click="execSave" :disabled="isSubmitting">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'warehouse-price-adjustment',
    data() {
        return {

            initStatus: 0,
            isSubmitting: false,
            isFetching: false,

            mode: 1, // 1: HP, 2: Non-HP
            activeItems: [],

            fields: [
				{ key: "from", label: "Dari", sortable: true},
                { key: "to", label: "Sampai", sortable: true},
				{ key: "online", label: "Grosir Online", sortable: true},
				{ key: "retail", label: "Retail", sortable: true},
                { key: "action", label: "Aksi"}
            ],

            inputs: ["from", "to", "online", "retail"],

            itemsHp: [],
            itemsNonHp: [],

            hpLastUpdated: { at: "", by: "" },
            nonHpLastUpdated: { at: "", by: "" },

            sortBy: null,
            sortDesc: false,

        }
    },
    methods: {

        init() {

            this.initStatus = 0
            this.getItems()

        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
        },
        
        getItems(){
            let param = ""
            if(!this.$helper.isBlank(this.sortBy)) {
                param += "?sortBy=" + this.sortBy
                param += "&sortDesc=" + this.sortDesc
            }
            this.$axios.get("/master/warehouse-price-adjustment" + param).then(res => {

                let data = res.data.data
                this.itemsHp = data.hp.entries
                this.itemsNonHp = data.nonHp.entries
                this.hpLastUpdated.at = data.hp.lastUpdatedAt
                this.hpLastUpdated.by = data.hp.lastUpdatedBy
                this.nonHpLastUpdated.at = data.nonHp.lastUpdatedAt
                this.nonHpLastUpdated.by = data.nonHp.lastUpdatedBy
                this.sanitizeAll()

                if(this.mode == 2){
                    this.activeItems = this.itemsNonHp
                }
                else{
                    this.activeItems = this.itemsHp
                }
                
                this.initStatus = 1

            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },

        confirmSave() {

            if(this.activeItems[0].from != "0") {
                return this.$helper.toastError(this, "Baris pertama harus dimulai dengan dari Rp 0!")
            }

            for(var i = 0; i < this.activeItems.length; i++) {
                for(var j = 0; j < this.inputs.length; j++) {
                    if(this.activeItems[i][this.inputs[j]] == "") {
                        return this.$helper.toastError(this, "Terdapat kotak yang kosong, mohon cek kembali!")
                    }
                }
            }

            this.$bvModal.show("m-confirm")

        },

        execSave() {

            let entries = []
            this.activeItems.forEach(it => {
                entries.push({
                    from: this.$helper.toNumber(it.from),
                    to: this.$helper.toNumber(it.to),
                    online: this.$helper.toNumber(it.online),
                    retail: this.$helper.toNumber(it.retail)
                })
            })

            let payload = {
                mode: this.mode,
                entries: entries
            }

            this.isSubmitting = true
            this.$axios.post("/master/warehouse-price-adjustment", payload).then(res => {

                let data = res.data.data
                if(this.mode == 1) {
                    this.hpLastUpdated.at = data.at
                    this.hpLastUpdated.by = data.by
                }
                else {
                    this.nonHpLastUpdated.at = data.at
                    this.nonHpLastUpdated.by = data.by
                }

                this.activeItems[this.activeItems.length - 1].to = "99.999.999.999"

                this.$bvModal.hide("m-confirm")
                this.$helper.toastSuccess(this, "Rumus umum untuk " + (this.mode == 1 ? "Handphone" : "Non-handphone") + " berhasil disimpan!")

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        addRow(index) {
            this.activeItems.splice(index + 1, 0, { from: "", to: "", online: "", retail: "" })
        },

        deleteRow(index) {
            this.activeItems.splice(index, 1)
        },

        switchMode(newMode) {

            if(this.mode == 1 && newMode == 2) {
                this.mode = 2
                this.activeItems = this.itemsNonHp
            }
            else if(this.mode == 2 && newMode == 1) {
                this.mode = 1
                this.activeItems = this.itemsHp
            }

        },

        sanitize(item, varName) {

            let cleaned = String(item[varName]).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            item[varName] = res

        },

        sanitizeAll() {

            this.itemsHp.forEach(it => {
                this.inputs.forEach(v => this.sanitize(it, v))
            })

            this.itemsNonHp.forEach(it => {
                this.inputs.forEach(v => this.sanitize(it, v))
            })

        }

    },

    created() {
        this.init()
    }
}
</script>
